import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from '@/lib/baseQuery';

export interface TaxEntry {
  id: string;
  form_id: string;
  '1.3': string; // First
  '1.4'?: string; // Middle
  '1.6': string; // Last
  '3': string; // Email
  '4'?: string; // Phone
  '20': string; // Country
  '16'?: string; // DOB
  '9'?: string; // TFN Number
  date_created?: string; // ISO 8601 — from Gravity Forms API
  date_updated?: string; // ISO 8601 — from Gravity Forms API
  [key: string]: any; // other fields
}

export interface TaxEntryResponse {
  statusCode: number;
  message: string;
  data: {
    total_count: number;
    entries: TaxEntry[];
  };
}

export interface TaxEntryByIdResponse {
  statusCode: number;
  message: string;
  data: TaxEntry;
}

export const taxEntriesApi = createApi({
  reducerPath: 'taxEntriesApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getTaxEntries: builder.query<
      TaxEntryResponse,
      { formId: string; page: number; pageSize: number; search?: string }
    >({
      query: ({ formId, page, pageSize, search }) => {
        const params = new URLSearchParams();
        params.append('current_page', page.toString());
        params.append('page_size', pageSize.toString());
        params.append('_labels', 'true');
        if (search) params.append('search_term', search);

        return `/v1/tax/process/${formId}/entries?${params.toString()}`;
      },
    }),
    getTaxEntryById: builder.query<
      TaxEntryByIdResponse,
      { formId: string; entryId: string }
    >({
      query: ({ formId, entryId }) =>
        `/v1/tax/process/${formId}/entries/${entryId}`,
    }),
  }),
});

export const { useGetTaxEntriesQuery, useGetTaxEntryByIdQuery } = taxEntriesApi;
